<div class="block" style="margin-top: 2%; margin-bottom: 0"
     *ngIf="waterQualityBatchReadingsList && waterQualityBatchReadingsList.length > 0">
  <div class="batch-data-block">
    <div *ngFor="let item of waterQualityBatchReadingsList; let i = index">
      <p class="batchdata" (click)="getBatchDetails(item.id, item.from_Date, item.to_Date)">
        <span>{{item.batch_number}}</span>
        <span
          style="margin-left: 20px;">Batch Created Date Time: {{((item.createdAt.split('T')[0]) | date)}} {{convertTo24Hrs(item.createdAt)}}</span>
        <span
          style="margin-left: 20px; float: right">Readings Date Time: {{(item.from_Date) + '  -  ' + (item.to_Date)}} {{convertTo24Hrs(item.time)}}</span>
      </p>
    </div>
    <div *ngIf="listLoader" class="loader-div">
      <div class="adjust">
        <div class="loader2 list-loader"></div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="myModal" role="dialog">
    <div class="modal-dialog modal-lg">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" title="Close Popup" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div *ngIf="selectedBatchTimeStamp" class="time-stamp-div">
              <span
                class="time-stamp-span">Batch Water Readings Date: {{(selectedBatchTimeStamp)}}</span>
          </div>
          <diV class="custom-scroll-bar" *ngIf="waterReadingsLogs && waterReadingsLogs.length > 0"
               [ngClass]="{'custom-scroll-bar': waterReadingsLogs && waterReadingsLogs.length > 2}">
            <div *ngFor="let pond of pondDetails_dropDown; let i = index;" class="ponds_container">
              <div>
                <div class="pond_card_header">
                  <span class="text">{{pond.pond_name}}</span>
                  <div>
                    <span title="Delete card" class="deletebtn"><i class="fa fa-trash-o" (click)="removePond(i)"
                                                                   *ngIf="showInput"></i></span>
                    <!-- <span class="icon"><i class="fa fa-edit" (click)="enablingInputFieldsForUpdate(i)"></i></span> -->
                  </div>
                </div>
                <div class="row row-flex pond_card_body">
                  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12"
                       *ngIf="pond.waterQualityLogs.pH && pond.waterQualityLogs.pH > 0">
                    <div class="parameter_container">
                      <span class="parameter_name">PH</span>
                      <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                                   [(ngModel)]="pond.waterQualityLogs.pH"
                                   (ngModelChange)="onEditValueChange(i, 'pH', pond.waterQualityLogs.pH)"
                                   [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;mol/ltr</span>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12"
                       *ngIf="pond.waterQualityLogs.salinity && pond.waterQualityLogs.salinity > 0">
                    <div class="parameter_container">
                      <span class="parameter_name">Salinity</span>
                      <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                                   [(ngModel)]="pond.waterQualityLogs.salinity"
                                   (ngModelChange)="onEditValueChange(i, 'salinity', pond.waterQualityLogs.salinity)"
                                   [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;ppt</span>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12"
                       *ngIf="pond.waterQualityLogs.alkalinity && pond.waterQualityLogs.alkalinity > 0">
                    <div class="parameter_container">
                      <span class="parameter_name">Alkalinity</span>
                      <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                                   [(ngModel)]="pond.waterQualityLogs.alkalinity"
                                   (ngModelChange)="onEditValueChange(i, 'alkalinity', pond.waterQualityLogs.alkalinity)"
                                   [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;ppm</span>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12"
                       *ngIf="pond.waterQualityLogs.turbidity && pond.waterQualityLogs.turbidity > 0">
                    <div class="parameter_container">
                      <span class="parameter_name">Turbidity</span>
                      <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                                   [(ngModel)]="pond.waterQualityLogs.turbidity"
                                   (ngModelChange)="onEditValueChange(i, 'turbidity', pond.waterQualityLogs.turbidity)"
                                   [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;ntu</span>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12"
                       *ngIf="pond.waterQualityLogs.tan && pond.waterQualityLogs.tan > 0">
                    <div class="parameter_container">
                      <span class="parameter_name">Tan</span>
                      <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                                   [(ngModel)]="pond.waterQualityLogs.tan"
                                   (ngModelChange)="onEditValueChange(i, 'tan', pond.waterQualityLogs.tan)"
                                   [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;ppm</span>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12"
                       *ngIf="pond.waterQualityLogs.temperature && pond.waterQualityLogs.temperature > 0">
                    <div class="parameter_container">
                      <span class="parameter_name">Temperature</span>
                      <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                                   [(ngModel)]="pond.waterQualityLogs.temperature"
                                   (ngModelChange)="onEditValueChange(i, 'temperature', pond.waterQualityLogs.temperature)"
                                   [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;°C</span>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12"
                       *ngIf="pond.waterQualityLogs.uam && pond.waterQualityLogs.uam > 0">
                    <div class="parameter_container">
                      <span class="parameter_name">U.Ammonia</span>
                      <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                                   [(ngModel)]="pond.waterQualityLogs.uam"
                                   (ngModelChange)="onEditValueChange(i, 'uam', pond.waterQualityLogs.uam)"
                                   [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;ppm</span>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12"
                       *ngIf="pond.waterQualityLogs.sg && pond.waterQualityLogs.sg > 0">
                    <div class="parameter_container">
                      <span class="parameter_name">Specific Gravity</span>
                      <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                                   [(ngModel)]="pond.waterQualityLogs.sg"
                                   (ngModelChange)="onEditValueChange(i, 'sg', pond.waterQualityLogs.sg)"
                                   [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;cm</span>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12"
                       *ngIf="pond.waterQualityLogs.do2 && pond.waterQualityLogs.do2 > 0">
                    <div class="parameter_container">
                      <span class="parameter_name">Do2</span>
                      <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                                   [(ngModel)]="pond.waterQualityLogs.do2"
                                   (ngModelChange)="onEditValueChange(i, 'do2', pond.waterQualityLogs.do2)"
                                   [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;mg/l</span>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12"
                       *ngIf="pond.waterQualityLogs.conductivity && pond.waterQualityLogs.conductivity > 0">
                    <div class="parameter_container">
                      <span class="parameter_name">Conductivity</span>
                      <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                                   [(ngModel)]="pond.waterQualityLogs.conductivity"
                                   (ngModelChange)="onEditValueChange(i, 'conductivity', pond.waterQualityLogs.conductivity)"
                                   [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;ppm</span>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12"
                       *ngIf="pond.waterQualityLogs.tds && pond.waterQualityLogs.tds > 0">
                    <div class="parameter_container">
                      <span class="parameter_name">TDS</span>
                      <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                                   [(ngModel)]="pond.waterQualityLogs.tds"
                                   (ngModelChange)="onEditValueChange(i, 'tds', pond.waterQualityLogs.tds)"
                                   [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;ppm</span>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12"
                       *ngIf="pond.waterQualityLogs.nitrite && pond.waterQualityLogs.nitrite > 0">
                    <div class="parameter_container">
                      <span class="parameter_name">Nitrite</span>
                      <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                                   [(ngModel)]="pond.waterQualityLogs.nitrite"
                                   (ngModelChange)="onEditValueChange(i, 'nitrite', pond.waterQualityLogs.nitrite)"
                                   [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;ppm</span>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12"
                       *ngIf="pond.waterQualityLogs.orp && pond.waterQualityLogs.orp > 0">
                    <div class="parameter_container">
                      <span class="parameter_name">ORP</span>
                      <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                                   [(ngModel)]="pond.waterQualityLogs.orp"
                                   (ngModelChange)="onEditValueChange(i, 'orp', pond.waterQualityLogs.orp)"
                                   [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;mV</span>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12"
                       *ngIf="pond.waterQualityLogs.magnesium && pond.waterQualityLogs.magnesium > 0">
                    <div class="parameter_container">
                      <span class="parameter_name">Magnesium</span>
                      <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                                   [(ngModel)]="pond.waterQualityLogs.magnesium"
                                   (ngModelChange)="onEditValueChange(i, 'magnesium', pond.waterQualityLogs.magnesium)"
                                   [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;ppm</span>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12"
                       *ngIf="pond.waterQualityLogs.calcium && pond.waterQualityLogs.calcium > 0">
                    <div class="parameter_container">
                      <span class="parameter_name">Calcium</span>
                      <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                                   [(ngModel)]="pond.waterQualityLogs.calcium"
                                   (ngModelChange)="onEditValueChange(i, 'calcium', pond.waterQualityLogs.calcium)"
                                   [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;ppm</span>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12"
                       *ngIf="pond.waterQualityLogs.plankton && pond.waterQualityLogs.plankton > 0">
                    <div class="parameter_container">
                      <span class="parameter_name">Plankton</span>
                      <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                                   [(ngModel)]="pond.waterQualityLogs.plankton"
                                   (ngModelChange)="onEditValueChange(i, 'plankton', pond.waterQualityLogs.plankton)"
                                   [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;No/L</span>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12"
                       *ngIf="pond.waterQualityLogs.bod && pond.waterQualityLogs.bod > 0">
                    <div class="parameter_container">
                      <span class="parameter_name">BOD</span>
                      <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                                   [(ngModel)]="pond.waterQualityLogs.bod"
                                   (ngModelChange)="onEditValueChange(i, 'bod', pond.waterQualityLogs.bod)"
                                   [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;mg/L</span>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12"
                       *ngIf="pond.waterQualityLogs.co2 && pond.waterQualityLogs.co2 > 0">
                    <div class="parameter_container">
                      <span class="parameter_name">Co2</span>
                      <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                                   [(ngModel)]="pond.waterQualityLogs.co2"
                                   (ngModelChange)="onEditValueChange(i, 'co2', pond.waterQualityLogs.co2)"
                                   [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;ppm</span>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12"
                       *ngIf="pond.waterQualityLogs.phosphorus && pond.waterQualityLogs.phosphorus > 0">
                    <div class="parameter_container">
                      <span class="parameter_name">Phosphorous</span>
                      <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                                   [(ngModel)]="pond.waterQualityLogs.phosphorus"
                                   (ngModelChange)="onEditValueChange(i, 'phosphorus', pond.waterQualityLogs.phosphorus)"
                                   [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;mg/L</span>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12"
                       *ngIf="pond.waterQualityLogs.h2sGas && pond.waterQualityLogs.h2sGas > 0">
                    <div class="parameter_container">
                      <span class="parameter_name">H2s-Gas</span>
                      <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                                   [(ngModel)]="pond.waterQualityLogs.h2sGas"
                                   (ngModelChange)="onEditValueChange(i, 'h2sGas', pond.waterQualityLogs.h2sGas)"
                                   [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;ppm</span>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12"
                       *ngIf="pond.waterQualityLogs.iron && pond.waterQualityLogs.iron > 0">
                    <div class="parameter_container">
                      <span class="parameter_name">Iron</span>
                      <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                                   [(ngModel)]="pond.waterQualityLogs.iron"
                                   (ngModelChange)="onEditValueChange(i, 'iron', pond.waterQualityLogs.iron)"
                                   [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;ppm</span>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12"
                       *ngIf="pond.waterQualityLogs.potassium && pond.waterQualityLogs.potassium > 0">
                    <div class="parameter_container">
                      <span class="parameter_name">Potassium</span>
                      <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                                   [(ngModel)]="pond.waterQualityLogs.potassium"
                                   (ngModelChange)="onEditValueChange(i, 'potassium', pond.waterQualityLogs.potassium)"
                                   [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;ppm</span>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12"
                       *ngIf="pond.waterQualityLogs.da && pond.waterQualityLogs.da > 0">
                    <div class="parameter_container">
                      <span class="parameter_name">D.A</span>
                      <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                                   [(ngModel)]="pond.waterQualityLogs.da"
                                   (ngModelChange)="onEditValueChange(i, 'da', pond.waterQualityLogs.da)"
                                   [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;%</span>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12"
                       *ngIf="pond.waterQualityLogs.sodium && pond.waterQualityLogs.sodium > 0">
                    <div class="parameter_container">
                      <span class="parameter_name">Sodium</span>
                      <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                                   [(ngModel)]="pond.waterQualityLogs.sodium"
                                   (ngModelChange)="onEditValueChange(i, 'sodium', pond.waterQualityLogs.sodium)"
                                   [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;ppm</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="padding: 15px;float: left;">
              <span class="more_parameters_text" (click)="showUnUsedPonds('showPonds')"
                    *ngIf="!showOrHidePonds && previewButton && dupPondDetails_dropDown.length != customerPonds.length">Add More ponds</span>
              <span class="more_parameters_text" (click)="showUnUsedPonds('removePonds')"
                    *ngIf="showOrHidePonds && previewButton && dupPondDetails_dropDown.length != customerPonds.length">Remove more ponds</span>
            </div>
          </diV>
          <div class="row">
            <div style="text-align: center; margin: 2% 0%;">
              <button type="button" *ngIf="editButton" [ngClass]="isCommitDisabled ? 'disbledCls' : ''"
                      (click)="enablingInputFieldsForUpdate()" class="btn btn-default transactionsubmit">Edit
              </button>
              <button type="button" *ngIf="cancelButton" (click)="cancelWaterQualityReadingsUpdate()"
                      class="btn btn-default transactionsubmit">Cancel
              </button>
              <button type="button" *ngIf="submitButton" [ngClass]="isCommitDisabled ? 'disbledCls' : ''"
                      (click)="updateBatchWaterQualityReadings()" class="btn btn-default transactionsubmit">Update
              </button>
              <button type="button" *ngIf="previewButton" (click)="previewBatchWaterQualityReadings()"
                      class="btn btn-default transactionsubmit">Preview
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
